import { ApiResponse } from 'apisauce';
import store from 'State/Redux';
import EndorsementDto from 'Models/Endorsement/Dto/EndorsementDto';
import UpdateEndorsementDto from 'Models/Endorsement/Dto/UpdateEndorsementDto';
import { withAccessToken, createApi } from '.';

export interface EndorsementServiceType {
   getEndorsementsHistoryById(id: string): Promise<ApiResponse<EndorsementDto[]>>;
   updateEndorsement(data: UpdateEndorsementDto): Promise<ApiResponse<EndorsementDto>>;
   getActiveEndorsementsByContactId(contactId: string): Promise<ApiResponse<EndorsementDto[]>>;
}

const create = (baseURL: string | undefined): EndorsementServiceType => {
   const api = createApi({ baseURL });

   const getEndorsementsHistoryById = (
      id: string
   ): Promise<ApiResponse<EndorsementDto[]>> => {
      const authApi = withAccessToken(api, store.getState().oidc);
      return authApi.get(`/Endorsements/History/${id}`);
   };

   const updateEndorsement = (
      data: UpdateEndorsementDto
   ): Promise<ApiResponse<EndorsementDto>> => {
      const authApi = withAccessToken(api, store.getState().oidc);
      return authApi.put(`/Endorsements/UpdateStatus`, data);
   };

   const getActiveEndorsementsByContactId = (
      contactId: string
   ): Promise<ApiResponse<EndorsementDto[]>> => {
      const authApi = withAccessToken(api, store.getState().oidc);
      return authApi.get(`/Endorsements/${contactId}`);
   };

   return {
      getEndorsementsHistoryById,
      updateEndorsement,
      getActiveEndorsementsByContactId,
   };
};

export default {
   create,
};
